import { useState, useEffect, useRef } from "react";
import { api, errMsg } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { toast } from "sonner";
import { Send } from "lucide-react";

export default function PortalMessages() {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const bottomRef = useRef(null);

  const load = () => api.get("/portal/messages").then((r) => setMessages(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async () => {
    if (!text.trim()) return;
    try {
      const { data } = await api.post("/portal/messages", { text: text.trim() });
      setMessages((m) => [...m, data]);
      setText("");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid="portal-messages-page">
      <h1 className="font-heading font-bold text-2xl mb-6">Support</h1>
      <div className="rounded-xl border bg-card flex flex-col h-[560px]">
        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {messages.length === 0 && <p className="text-sm text-muted-foreground text-center py-10">Send us a message — a coordinator will respond shortly.</p>}
          {messages.map((m) => (
            <div key={m.id} className={`flex ${m.sender === "customer" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[75%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${m.sender === "customer" ? "bg-[var(--cc-accent)] text-black font-medium" : "bg-secondary border"}`}>
                {m.sender !== "customer" && <p className="overline-cc mb-1">CastleCorp Ops</p>}
                {m.text}
                <p className={`text-[10px] mt-1.5 font-mono-cc ${m.sender === "customer" ? "text-black/50" : "text-muted-foreground"}`}>{new Date(m.created_at).toLocaleString()}</p>
              </div>
            </div>
          ))}
          <div ref={bottomRef} />
        </div>
        <div className="border-t p-4 flex gap-2">
          <Input data-testid="portal-message-input" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Type a message to our team..." />
          <Button data-testid="portal-message-send-button" onClick={send} size="icon" className="btn-glow shrink-0 bg-[var(--cc-accent)] text-black hover:bg-[var(--cc-accent)]/90"><Send className="w-4 h-4" /></Button>
        </div>
      </div>
    </div>
  );
}
